import React, { PureComponent, Fragment } from 'react';
import { connect } from 'dva';
import { Link } from 'dva/router';
import styles from './index.less';
import { Steps, Button, Card, message, Select, Row, Col } from 'antd';
import PageHeaderWrapper from '@/components/PageHeaderWrapper';
import { PATH_DASHBOARD } from '@/utils/routes/path';

const { Option } = Select;

const steps = [
  {
    title: 'Create IAM Roles',
    content:
      'Click on the button below to download AWS Cloudformation Templates\n' +
      'These templates will be used to create following IAM Roles in your AWS account\n\n' +
      'Stack set roles\n' +
      '1) Administrator Role\n' +
      '2) Execution Role\n\n' +
      'NOTE: These both roles are pre-requisites for using stacksets.\nFor more information regarding these IAM roles <a target="blank" href="https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/stacksets-prereqs.html"> <b>Click here</b> </a>\n\n',
  },
  {
    title: 'Create StackSet',
    content:
      'Open <a target="blank" href="https://console.aws.amazon.com/cloudformation/"> AWS Cloudformation Console </a>\n' +
      'Then in AWS console\n' +
      '1) Click on Create Stack\n' +
      '2) Upload the cloudformation template downloaded previously\n' +
      '3) Enter Stack Name and click Next\n' +
      '4) Make sure to mark checkbox in Capabilities section\n' +
      '5) Press Create button\n' +
      'For more details on steps of creating stack set <a target="blank" href="https://cloudnosys.com/docs/eagleeye-live-monitoring-setup/"> <b>Click here</b> </a>',
  },
  {
    title: 'Finish',
    content:
      'The process may take from 5 minutes to more than an hour to get completed, depending upon the regions you have selected while creating stackset\n' +
      'In case of any errors or difficulties, <a  href="mailto:support@cloudnosys.com">Contact Us</a>\n' +
      'Press Done after your stackset is successfully created\n',
  },
];
@connect(({ cloudAccounts, cloudAccount, organisation }) => ({
  cloudAccounts,
  cloudAccount,
  organisation: organisation.current,
}))
class RealTimeAlerts extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      loadings: false,
      downloaded: false,
      time: 5,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'cloudAccounts/fetchCloudAccounts',
      payload: {
        force: true,
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cloudAccount.eagleEyeUrl !== this.props.cloudAccount.eagleEyeUrl) {
      const { eagleEyeUrl, eagleEyeStatus } = this.props.cloudAccount;
      let url_string = window.location.href;
      let url = new URL(url_string);
      if (eagleEyeUrl !== '' && eagleEyeStatus === '') {
        this.setState({ loadings: false });
        const { dispatch } = this.props;
        dispatch({
          type: 'cloudAccount/save',
          payload: {
            eagleEyeUrl: '',
          },
        });
        window.open(eagleEyeUrl, '_blank');
      }
    }
  }

  // to download role template and pass to models
  downloadRoleTemplate = cloudAccount => {
    let { dispatch, organisation } = this.props;
    this.setState({ loadings: true, downloaded: true });
    const { time } = this.state;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'template',
          orgId: organisation.id,
          time,
          id: cloudAccount,
        },
      },
    });
    dispatch({
      type: 'cloudAccount/current',
      payload: {
        params: {
          orgId: organisation.id,
          id: cloudAccount,
        },
      },
    });
    message.success('Template will be downloaded shortly');
  };

  downloadExecutionRole() {
    let { dispatch } = this.props;
    const { current } = this.state;
    window.open(
      `https://s3.amazonaws.com/cloudformation-stackset-sample-templates-us-east-1/AWSCloudFormationStackSetExecutionRole.yml`,
      '_blank'
    );
  }

  downloadAdminRole() {
    let { dispatch } = this.props;
    const { current } = this.state;
    window.open(
      `https://s3.amazonaws.com/cloudformation-stackset-sample-templates-us-east-1/AWSCloudFormationStackSetAdministrationRole.yml`,
      '_blank'
    );
  }

  done(orgId, cloudAccount) {
    let { dispatch } = this.props;
    const { current } = this.state;
    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'eagleEye',
          orgId: orgId,
          id: cloudAccount,
        },
      },
    });
  }

  handleChange = value => {
    const { downloaded } = this.state;
    if (downloaded !== false) message.success('downlaod template again to update value');
    this.setState({ time: parseInt(value.value), downloaded: false });
  };

  next() {
    const current = this.state.current + 1;
    this.setState({ current });
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  render() {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let cloudAccount = url.searchParams.get('cloud-account');
    let userId = url.searchParams.get('userId');
    let orgId = url.searchParams.get('orgId');

    const regions = this.props.cloudAccounts.data.list;
    const selectedCloudAccount = regions.filter(singleRegion => singleRegion.id === cloudAccount);

    const { loadings } = this.state;
    const { Step } = Steps;
    const { current } = this.state;

    return (
      <Fragment>
        <PageHeaderWrapper title="EagleEye" content={<div />}>
          <Card className={styles.stepsCard}>
            <div>
              <Steps current={current}>
                {steps.map(item => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
              {current === 1 && (
                <div style={{ marginTop: 30 }}>Select risks generating interval</div>
              )}
              <Row style={{ marginBottom: -70, marginTop: 10 }}>
                <Col>
                  {current === 1 && (
                    <Select
                      labelInValue
                      defaultValue={{ value: '5' }}
                      style={{ width: 120 }}
                      onChange={this.handleChange}
                    >
                      <Option value="5">5 min</Option>
                      <Option value="15">15 min</Option>
                      <Option value="60">1 hr</Option>
                    </Select>
                  )}
                </Col>
                <Col>
                  {current === 1 && (
                    <Button
                      style={{ marginLeft: 5 }}
                      type="primary"
                      onClick={() => this.downloadRoleTemplate(cloudAccount)}
                      loading={loadings}
                    >
                      {' '}
                      Download Template
                    </Button>
                  )}
                </Col>
              </Row>

              <br />
              <div className={styles.stepsContent}>
                <p dangerouslySetInnerHTML={{ __html: steps[current].content }} />
                {current === 1 && (
                  <div>
                    Note: Please create the stackset and select all the regions in which you want to
                    get alerts in Cloudnosys through Eagle eye <br />
                  </div>
                )}
                {current === 0 && (
                  <Button
                    style={{ float: 'left', marginRight: 10, marginTop: 10 }}
                    type="primary"
                    onClick={() => this.downloadAdminRole()}
                  >
                    Administrator Role
                  </Button>
                )}
                {current === 0 && (
                  <Button
                    style={{ float: 'left', marginTop: 10 }}
                    type="primary"
                    onClick={() => this.downloadExecutionRole()}
                  >
                    Execution Role
                  </Button>
                )}
              </div>
              {/* this.downloadRoleTemplate(this.props.match.params.userId, this.props.match.params.cloudAccount) */}
              <div className="steps-action">
                {current < steps.length - 1 && (
                  <Button
                    style={{ float: 'right', marginTop: 80 }}
                    type="primary"
                    onClick={() => this.next()}
                    // loading
                  >
                    {' '}
                    Next{' '}
                  </Button>
                )}
                {current === steps.length - 1 && (
                  <Link to={PATH_DASHBOARD.setup.cloudAccounts}>
                    <Button
                      style={{ float: 'right', marginTop: 80 }}
                      type="primary"
                      onClick={() => this.done(orgId, cloudAccount)}
                    >
                      Done
                    </Button>
                  </Link>
                )}
                {current > 0 && (
                  <Button
                    style={{ float: 'right', marginRight: 10, marginTop: 80 }}
                    onClick={() => this.prev()}
                  >
                    Previous
                  </Button>
                )}
              </div>
            </div>
          </Card>
        </PageHeaderWrapper>
      </Fragment>
    );
  }
}

export default RealTimeAlerts;
